export interface EngineConfig {
    id: Engine;
    label: string;
    icon: string;
    color: string;
    report?: string;
}

export type Engine = typeof Engines[number];

export const Engines = [
    'PLATFORM',
    'INBOUND_MESSAGE',
    'LISTENING',
    'LISTENING_EXPLORER',
    'SELF_SERVE_LISTENING',
    'BENCHMARKING',
    'UNIFIED_ANALYTICS_REPORTING_ENGINE',
    'PAID',
    'CAMPAIGN',
    'TWITTER',
    'HISTORIC_TRENDS',
    'ADVOCACY',
    'RDB_FIREHOSE',
    'STORY_MESSAGE',
    'MONITORING_DASHBOARD',
    'TRENDING_EVENT',
    'UNIVERSAL_PROFILE',
    'SPR_TASK',
    'CUSTOM_ENTITY',
    'VOICE',
    'COMMUNITY',
    'SAM',
    'AUDIENCE_ACTIVITY',
    'OUTBOUND_MESSAGE',
    'CONSUMPTION',
];
